var _path, _path2, _g, _path3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowThrough({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.826172 33.7H33.8262V0.699951H0.826172V33.7Z",
    fill: "#F3F4F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2630_27407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8262 0.699951H0.826172V33.7H33.8262V0.699951Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2630_27407)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.07617 25.45H25.5762V8.94995H9.07617V25.45Z",
    fill: "#666666"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2630_27407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8262 0.699951H0.826172V33.7H33.8262V0.699951Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2630_27407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2012 19.325C13.2012 20.4295 14.0966 21.325 15.2012 21.325H19.4512C20.5557 21.325 21.4512 20.4295 21.4512 19.325V15.075C21.4512 13.9704 20.5557 13.075 19.4512 13.075H15.2012C14.0966 13.075 13.2012 13.9704 13.2012 15.075V19.325Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowThrough);
export default __webpack_public_path__ + "static/media/show-through.685022dbd04ac619aa114119e2ffef07.svg";
export { ForwardRef as ReactComponent };